module.exports = __webpack_public_path__ + "img/980747861.b77c5915.jpg";